import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-[100vw] h-[100vh] bg-[#0d1116] flex items-center justify-center" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center" }

import Heading from '@/components/HeadingComponent.vue'
import Toaster from '@/components/ToasterComponent.vue';
import TodoInput from '@/components/TodoInputComponent.vue';
import TodoList from '@/components/TodoListComponent.vue';
import { Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TodoApp',
  setup(__props) {

const heading: Ref<string> = ref('Todo App');
const todoLists: Ref<string[]> = ref([]);
const toaster: Ref<boolean> = ref(false)
const toasterMessage: Ref<string> = ref('List updated!')
const timeOut: Ref<any> = ref(null);

function handleToaster() {
  toaster.value = true;
  if (timeOut.value) {
    clearTimeout(timeOut.value)
  }
  timeOut.value = setTimeout(() => {
    toaster.value = false;
  }, 1000);
}

function handleSubmit(input: string) {
  todoLists.value.push(input);
  handleToaster();
}

function handleFilter(index: number) {
  todoLists.value = todoLists.value.filter((_, id: number) => id !== index);
  handleToaster();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Heading, { title: heading.value }, null, 8, ["title"]),
      _createVNode(TodoInput, { onHandleSubmit: handleSubmit }),
      _createVNode(TodoList, {
        "todo-lists": todoLists.value,
        onHandleFilter: handleFilter
      }, null, 8, ["todo-lists"]),
      (toaster.value)
        ? (_openBlock(), _createBlock(Toaster, {
            key: 0,
            message: toasterMessage.value
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})